import Module, { bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import LoginView from "./login_view";
import ModuleManager from '../../../../framework/core/module_manager';
import Utility from "../../../../utility/utility";
import LoaclStorage from "../../../../manager/local_storage";
import AppData from '../../../public/const/app_data';
import AudioManager from "../../../../manager/audio_manager";
import LanguageManager from '../../../../manager/language_manager';
import HallServer from "../../server/hall/hall_serve";
import EventManager from "../../../../manager/event_manager";
import { GameManager } from "../../../../manager/game_manager";
// import { GameManager } from '../../../../manager/game_manager';
import SdkManager from "../../../../manager/sdk_manager";
import SdkDefine from "../../../../sdk/collection/sdk_define";
import SdkStorage from "../../../../sdk/SdkStorage";
import SceneManager from "../../../../manager/scene_manager";
import { NotifyData } from "../../../public/notify_data";
import Test from "../test/test";
import Customer from "../customer/customer";
import WebFullScreen from "../../../public/module/web_fullscreen/webfullscreen";
import TimeManager from "../../../../manager/time_manager";
import bindingCellphone from "../bindingCellphone/bindingCellphone";
import LogManager from "../../../../manager/log_manager";
import OssManager from '../../../../manager/oss_manager';


const { ccclass, menu } = cc._decorator;

@ccclass
@menu("package/hall/login/LoginModule")
@moduleInit("LoginModule")
export default class LoginModule extends Module<LoginView, null> {

    //微信的用户是否授权了
    _wxScopeUserInfo: boolean = true
    //是否获取到了远程的服务器数据
    _getServerVersionData: boolean
    _startBtn = null
    _assets = null
    _testClickTimes: number = 0;
    constructor() {
        super();
        this.windowPrefabResPath = "package/hall/module/login/hall_login";
        this.viewType = LoginView;
        this.modelType = null;
    }

    onInit() {
        AudioManager.instance.playMusicLoop()
        this.eventBind("hall_show_type", (data) => {
            this.view.tweenTo(data)
        })
        cc.game.on("game_letteratlas_full", () => {
            cc.error("game_letteratlas_full")
        })
    }

    updateEditBoxAccount() {
        let loginUserID = LoaclStorage.getNumber("loginUserID", 0)
        let loginUserPassword = LoaclStorage.getString("loginUserPassword", "")


        if (loginUserID != 0 && loginUserPassword) {
            if (loginUserID > 1000) {
                this.view.editBoxAccount.string = loginUserID.toString() + "@" + loginUserPassword;
            } else {
                this.view.editBoxAccount.string = loginUserID.toString()
            }

        } else {
            this.view.editBoxAccount.string = (Math.floor(Math.random() * 900) + 100).toString()
        }
    }

    @bindButtonClickEvent("ButtonChangeLanguage")
    changeLanguage() {
        LanguageManager.change()
        this.view.changeLanguage()
        ModuleManager.instance.destroyAllModule()
        AppData.language = "en"
        ModuleManager.instance.showModule(LoginModule)
    }

    @bindButtonClickEvent("ButtonTest")
    test() {
        // jsb.Device.vibrate(0.5);
        // cc.log("setOrientation")
        // // cc.view.setOrientation(cc.macro.ORIENTATION_PORTRAIT)

        // if (cc.sys.isNative && cc.sys.os === cc.sys.OS_ANDROID) {
        //     jsb.reflection.callStaticMethod("project/AppActivity", "changeOrientation", "(I)V", 1);
        // } else if (cc.sys.isNative && cc.sys.os === cc.sys.OS_IOS) {
        //     jsb.reflection.callStaticMethod("IOSHelper", "changeOrientation:", 1);
        // }
        // else {
        //     cc.view.setOrientation(cc.macro.ORIENTATION_PORTRAIT);
        // }
        // let width = cc.view.getFrameSize().height > cc.view.getFrameSize().width ? cc.view.getFrameSize().width : cc.view.getFrameSize().height;
        // let height = cc.view.getFrameSize().height < cc.view.getFrameSize().width ? cc.view.getFrameSize().width : cc.view.getFrameSize().height;
        // cc.view.setFrameSize(width, height);
        // cc.view.setDesignResolutionSize(1080, 1920, cc.ResolutionPolicy.FIXED_HEIGHT);
        // ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
        // let data = {
        //     uerID: 0,
        //     password : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1NjI5ODQ2ODAsImlhdCI6MTU2Mjg5ODI4MCwidG9rZW4iOiI0MTNlZjExNzdhY2Y0MjlhOGQwMDk2ZDgzZjk4NmE4MiJ9.NWfpnjxqIcunyT8nfU98K_1ROGxCwKViL5Opq6-Jjaw",
        //     language: "zh_CN", //zh_CN en_US th_TH
        //     loginType : "5"
        //     // exJsonStr : ""
        // }
        // HallServer.instance.accountLoginWithData(data);
        // ModuleManager.instance.toast(LanguageManager.t("public_tiyanRoom", true))
        // this.view.tweenTo()
        // EventManager.instance.dispatch("hall_show_type", "LoadingToLogin")

        // let url = "https://zhaonuo-international-gameapp.oss-cn-hangzhou.aliyuncs.com/remote-assets/project.manifest";

        // url = "https://zhaonuo-international-game-apk.oss-cn-hangzhou.aliyuncs.com/VersionTest-debug.apk";

        // GameUtil.downFile2Local(url,
        //         "test",".apk",
        //         (progress : string)=>{
        //                 cc.log(" downFile2Local progress ", progress);
        //                 let text = "正在下载安装包,请耐心等待:" +  ( Number(progress) * 100).toFixed(0) + "%";
        //                 ModuleManager.instance.showModule(LoadingModule,{progress : progress,text: text } );
        //         },
        //         (err : string ,fullPath : string )=>{
        //             if (err) {
        //                 cc.log(" downFile2Local err ",err);
        //             }else{
        //                 cc.log(" downFile2Local finish !");    
        //                 //install apk
        //                 VersionManager.instance.removeStoragePath();

        //                 let className = "org/cocos2dx/javascript/sdk/MainSDKActivity";
        //                 let methodName = "installApk";               
        //                 let methodSignature = "(Ljava/lang/String;)V";
        //                 jsb.reflection.callStaticMethod(className, methodName,methodSignature,fullPath);
        //       }
        // });
    }

    onTextLoad(err, text) {
        cc.log("onTextLoad  err ", err, " text ", text);
    }

    @bindButtonClickEvent("Button_Login")
    onLoginBtnClick() {
        this._LoginWithId()
    }

    _LoginWithId() {
        let ts = this.view.editBoxAccount.string
        if (ts != "" && ts.includes("@")) {
            let tss = ts.split("@")
            // HallServer.instance.accountLogin(tss[0], tss[1], "", null, null, 5);  //暂时无法使用账号密码登陆
            this.testTokenLogin(tss[1])
        } else {
            let account = Number.parseInt(this.view.editBoxAccount.string)
            if (account && account >= 100 && account < 1000) {
                ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
                HallServer.instance.accountLogin(this.view.editBoxAccount.string, this.view.editBoxAccount.string, "", null, null, 5);
                LoaclStorage.setNumber("loginWithWX", 0)
            } else {
                ModuleManager.instance.toast("请输入正确的测试账号")
            }
        }

    }

    @bindButtonClickEvent("ButtonClear")
    onClearData() {
        GameManager.clearReboot()
    }

    @bindButtonClickEvent("Button_LoginFacebook")
    onButton_LoginFacebook() {
        Utility.reportEffect("login_clickLogin")
        if (!CC_PREVIEW) {
            Utility.reportEffect("login_clickFacebook")
            this.sdkLogin(SdkDefine.FACE_BOOK_NAME);
        } else {
            this._LoginWithId()
        }
    }

    @bindButtonClickEvent("Button_LoginLine")
    onButton_LoginLine() {
        Utility.reportEffect("login_clickLogin")
        if (!CC_PREVIEW) {
            Utility.reportEffect("login_clickLineLogin")
            this.sdkLogin(SdkDefine.LINE_NAME);
        } else {
            this._LoginWithId()
        }
    }

    @bindButtonClickEvent("Button_LoginDevice")
    onButton_LoginDevice() {
        Utility.reportEffect("login_clickLogin")
        this.deviceLogin()
    }

    @bindButtonClickEvent("Button_LoginPhone")
    onButton_LoginPhone(){
        Utility.reportEffect("login_clickPhoneLogin")
        if (!this.tokenLogin()) {
        
            ModuleManager.instance.showModule(bindingCellphone,{loginBinding : true});
        }
    }

    @bindButtonClickEvent("Button_Customer")
    onButton_Customer() {
        ModuleManager.instance.showModule<Customer>(Customer, {
            "customerType": 3,
        })
    }
    @bindButtonClickEvent("Button_Repair")
    onButton_Repair() {
        ModuleManager.instance.showDialogConfirmCancel("ฟังก์ชันการซ่อมแซมจะดาวน์โหลดข้อมูลของเกมอีกครั้ง จะดำเนินการต่อหรือไม่?", () => {
            if (CC_JSB) {
                AudioManager.instance.stopAllMusic()
                jsb.fileUtils.removeDirectory(jsb.fileUtils.getWritablePath() + 'remote-assets');
                cc.game.restart()
            } else {
                window.location.reload()
            }
            LoaclStorage.clear()
        }, null)
    }
    @bindButtonClickEvent("Button_Add")
    onButton_Add() {
        this.HideBtnShow(true)
        this.view.repairAnim.play()
        this.view.customerAnim.play()
        
        LogManager.instance.setTmpUidAndToken(99234898, "06f16eadc2f841348edcfa5384db06bd")
        // OssManager.instance.getOssParams(null, null)
        LogManager.instance.uploadLogFile(null)
    }
    @bindButtonClickEvent("Button_Less")
    onButton_Less() {
        let self = this
        let repairclip2 = this.view.repairAnim.getClips()[1]
        let customerclip2 = this.view.customerAnim.getClips()[1]
        this.view.repairAnim.play(repairclip2.name)
        this.view.customerAnim.play(customerclip2.name)
        this.view.customerAnim.once("stop", function () {
            self.HideBtnShow(false)
        })
    }

    @bindButtonClickEvent("ButtonDevelop", true)
    onButtonDevelop() {
        let isDevelop = LoaclStorage.getNumber("__isDevelopTestMode", 0)
        if (isDevelop > 0) {
            ModuleManager.instance.showModule<Test>(Test)
        } else {
            this._testClickTimes += 1;
            if (this._testClickTimes > 30) {
                ModuleManager.instance.showModule<Test>(Test)
            }
        }
    }

    private tokenLogin() {

        let token = SdkStorage.getLoginToken();
        if (!token) {
            return false;
        }

        //直接token登陆
        let jsonObj = {
            token: token,
            passportThridType: 4,
            deviceId: AppData.devicesId
        };
        SceneManager.loginFromAuth(JSON.stringify(jsonObj));

        return true;
    }

    private lineCodeLogin(): boolean {

        if (cc.sys.isBrowser) {

            let line_auth: string = LoaclStorage.getItem("__line_auth");
            if (!line_auth) {
                return false;
            }
            var vars = line_auth.split("&");
            if (vars.length < 3) {
                return false;
            }

            let line_redirect_uri = vars[0];
            let code = vars[1];
            let state = vars[2];

            if (state && code) {

                let jsonObj = {
                    code: code,
                    state: state,
                    passportThridType: 3,
                    deviceId: AppData.devicesId,
                    redirectUri: line_redirect_uri,
                };
                Utility.reportEffect("login_lineLoginCb")
                SceneManager.loginFromAuth(JSON.stringify(jsonObj));
                LoaclStorage.setItem("__line_auth", null);
                return true;
            }
        }

        return false;

    }


    deviceLogin(moduleShowAutoLogin?) {
        Utility.reportEffect("login_clickDevice")
        let cacheLoginData = LoaclStorage.getString("LocalPlayerLoginData", "")
        if (cacheLoginData == "") {
            let jsonObj = {
                thirdUnionId: AppData.devicesId,
                passportThridType: 0,
                gender: Math.floor(Math.random() * 100) % 2 + 1,
                nickname: "player" + Math.floor(Math.random() * 100000),
                headImg: (200 + Math.floor(Math.random() * 10 + 1)) + "png",
                deviceId: AppData.devicesId
            };
            cacheLoginData = JSON.stringify(jsonObj)
            LoaclStorage.setString("LocalPlayerLoginData", cacheLoginData)
        }
        SceneManager.loginFromAuth(cacheLoginData);
    }

    phoneLogin(thirdUnionId : string,verifyCode : string){

        let jsonObj = {
            deviceId: AppData.devicesId,
            thirdUnionId: thirdUnionId,
            passportThridType: 5,
            verifyCode: verifyCode,            
        };
        
        SceneManager.loginFromAuth(JSON.stringify(jsonObj));
    }

    private testTokenLogin(token) {

        if (!token || token == "" || token == undefined || token == null) {
            return;
        }


        //直接token登陆
        let jsonObj = {
            token: token,
            passportThridType: 4,
            deviceId: AppData.devicesId
        };
        SceneManager.loginFromAuth(JSON.stringify(jsonObj));
    }

    private sdkLogin(sdkName: string) {

        if (cc.sys.isNative) {

            SdkManager.instance.requestNativeFunc(sdkName, "req_login");
        }
        else if (cc.sys.isBrowser) {

            if (sdkName == SdkDefine.FACE_BOOK_NAME) {
                cc.game.emit('fb_login');
            } else if (sdkName == SdkDefine.LINE_NAME) {
                cc.game.emit("line_login")
            }
        }
    }

    onShow() {

        this.eventBind("event_binding_phone_num",this.on_binding_phone_num);

        Utility.reportEffect("init_login_show")
        GameManager.hideAndroidSplash()
        let develop = LoaclStorage.getNumber("__isDevelopTestMode", 0)
        cc.log("开发者模式", develop)
        this.dropDownInit(develop)
        this.view.panelTest.active = develop != 0
        NotifyData.instance.reset();
        GameManager.gameInited()
        // ModuleManager.instance.setModuleActive("HallBase", true)
        this.showLayerTop()
        HallServer.instance.resetConnectTimes()
        if (ModuleManager.instance.moduleHasActive("Hall")) {
            EventManager.instance.dispatch("hall_show_type", "HallToLogin")
        } else {
            EventManager.instance.dispatch("hall_show_type", "LoadingToLogin")
        }
        this.updateCheckState()
        if (!CC_JSB) {
            // ModuleManager.instance.preLoadRes()
        }

        //代表是否登录过

    
        this.autoLogin()

        this.updateEditBoxAccount()
        this.HideBtnShow(false)
        // this.showFullScreen()
        TimeManager.instance.initServerTime()
        //稍微延后点获取，不能太快了
        AppData.getOpeninstallData()
        // ModuleManager.instance.showModule<LoadingModule>(LoadingModule, "test")
    }

    private autoLogin() {
        if(!this.tokenLogin()){  //自动登录    
            // this.lineCodeLogin();
            // if (!AppData.startCheckGame && LoaclStorage.getNumber("LastLoginID", null) == null && LoaclStorage.getString("NewUserTriggerAutoLoginWithDevice", null) == null) {
            //     LoaclStorage.setNumber("NewUserTriggerAutoLoginWithDevice", 1)
            //     GameManager.reportConversionEvent("NewUserTrigger_AutoLoginWithDevice")
            //     this.deviceLogin()
            // } 
        }

    }

    private updateCheckState() {
        let self = this
        this.doScheduleOnce(() => {
            GameManager.getVersionConfigData((needUpdate, error) => {
                if (error) {
                    if (AppData.startCheckGame) {
                        self.updateCheckState()
                    }
                } else {
                    if (!AppData.startCheckGame && !AppData.alreadyShowHallScene) {  //如果处在审核状态不需要重启
                        self.autoLogin()
                    }
                    // self.needHideDeviceLoginButton()
                }
            })
        }, 0.1)
    }

    // private needHideDeviceLoginButton() {
    //     // if (CC_JSB && cc.sys.os == cc.sys.OS_IOS) {
    //     //     this.view.buttonLoginDevice.active = AppData.testMode ||  AppData.startCheckGame
    //     // }
    // }

    on_binding_phone_num( thirdUnionId : string, verifyCode : string){

        //console.log(" on_binding_phone_num ");
        this.phoneLogin(thirdUnionId,verifyCode);
    }

    showFullScreen() {
        if (cc.sys.isBrowser) {
            if (cc.sys.os == cc.sys.OS_ANDROID) {
                if (cc.sys.BROWSER_TYPE_CHROME == cc.sys.browserType) {
                    if (!window.matchMedia('(display-mode: standalone)').matches) {
                        ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
                    } else {
                        ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
                    }
                } else {
                    ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
                }
            } else if (cc.sys.os == cc.sys.OS_IOS) {
                if (Utility.isSafari() || Utility.openInFacebook() || Utility.openInLine()) {  //|| Utility.isFacebook() || Utility.isLine()
                    //@ts-ignore
                    if (!navigator.standalone) {
                        ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
                    }
                } else {
                    ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
                }
            } else {
                ModuleManager.instance.showModule<WebFullScreen>(WebFullScreen)
            }
        }
    }
    onHide() {
        this._testClickTimes = 0
    }

    dropDownInit(develop) {
        this.view.dropDownItemNode.active = false
        this.dropDownLabel()
        this.view.dropDownItem1.active = true
        this.view.dropDownItem2.active = develop >= 1
        this.view.dropDownItem3.active = develop == 2
    }

    HideBtnShow(show) {
        this.view.addBtnNode.active = !show
        this.view.lessBtnNode.active = show
        this.view.customerBtnNode.active = show
        this.view.repairBtnNode.active = show
    }

    dropDownLabel() {
        let server = AppData.userConnectEnvi
        let str: string = "正式服"
        if (server == 1) {
            str = "体验服"
        } else if (server == 2) {
            str = "测试服"
        }
        this.view.dropDownChooseLabel.string = str
    }
    @bindButtonClickEvent("DropDownChooseBtn")
    onDropDownChooseBtnClick() {
        this.view.dropDownItemNode.active = !this.view.dropDownItemNode.active
    }
    @bindButtonClickEvent("DropDownItemBtn0")
    onDropDownItemBtn0Click() {
        this.view.dropDownItemNode.active = !this.view.dropDownItemNode.active
        AppData.setServerByData(0)
        this.dropDownLabel()
        LoaclStorage.setNumber("__userConnectEnvi", AppData.userConnectEnvi)
    }
    @bindButtonClickEvent("DropDownItemBtn1")
    onDropDownItemBtn1Click() {
        this.view.dropDownItemNode.active = !this.view.dropDownItemNode.active
        AppData.setServerByData(1)
        this.dropDownLabel()
        LoaclStorage.setNumber("__userConnectEnvi", AppData.userConnectEnvi)
    }
    @bindButtonClickEvent("DropDownItemBtn2")
    onDropDownItemBtn2Click() {
        this.view.dropDownItemNode.active = !this.view.dropDownItemNode.active
        AppData.setServerByData(2)
        this.dropDownLabel()
        LoaclStorage.setNumber("__userConnectEnvi", AppData.userConnectEnvi)
    }
}




